import { useMutation } from '@tanstack/react-query';
import { sendFile } from 'config/requests';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { queryClient } from 'providers/queryClient';
import { useNotify } from 'react-admin';

import { UPLOAD_FILES } from './useGetFiles';

export function useSendFile() {
  const notify = useNotify();
  const translate = useTypedTranslate();

  const mutation = useMutation({
    mutationFn: (data: FormData) => sendFile(data),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: [UPLOAD_FILES] });

      notify(translate('app.common.fileUploaded', { type: 'success' }));
    },
  });
  return { sendFile: mutation };
}
